import {HttpClient, HttpHeaders, HttpParams} from '@angular/common/http';
import {Injectable} from '@angular/core';

import {Observable} from 'rxjs';

import {PoDynamicFormField, PoLookupColumn, PoLookupFilter, PoLookupFilteredItemsParams} from '@po-ui/ng-components';
import {environment} from 'src/environments/environment';
import { GrupoCliente } from '../interface/grupo-cliente';

@Injectable({
  providedIn: 'root'
})
export class GrupoClienteLookupService implements PoLookupFilter {
  url = `${environment.urlApiProtheus}/wsrgrupocliente`;

  constructor(private httpClient: HttpClient) {
  }

  getFilteredItems(filteredParams: PoLookupFilteredItemsParams): Observable<any> {
    const {filterParams, advancedFilters, ...restFilteredItemsParams} = filteredParams;
    const params = {...restFilteredItemsParams, ...filterParams, ...advancedFilters};

    return this.httpClient.get(this.url, {params});
  }

  getObjectByValue(value: string): Observable<GrupoCliente> {
    return this.httpClient.get<GrupoCliente>(`${this.url}/${value}}`);
  }

  getAdvancedFilter(): Array<PoDynamicFormField> {
    return [
      {property: 'CACYGRPVEN', optional: true, gridColumns: 6, label: 'Código'},
      {property: 'CACYDESCRI', optional: true, gridColumns: 6, label: 'Descrição'},
    ];
  }

  getColumnsFilter(): Array<PoLookupColumn> {
    return [
      {property: 'CACYGRPVEN' , label: 'Código',    width: '35%'},
      {property: 'CACYDESCRI' , label: 'Descrição', width: '65%'},
    ];
  }

  getFieldFormater(value: any) {
    return `${value.CACYGRPVEN} - ${value.CACYDESCRI}`;
  }

}
